<mat-card>
  <mat-card-title fxLayout="row" fxLayoutAlign="space-between center">
    <h3 class="header-title">Select a Variant</h3>
    <button mat-icon-button (click)="onClose()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-card-title>
  <mat-divider></mat-divider>
  <mat-card-content class="card-container">
    <div
      class="product-listing"
      *ngFor="let idx of data.subProducts; let i = index"
      [class.active]="idx._id === data?.defaultSubProduct?._id"
      (click)="onSelectVariant(idx, i)">
      <div class="image-container">
        <img
          [src]="idx?.images?.length ? idx?.images[0]?.linkMd : data?.imageLink"
          [alt]="data.productName + '\'s Image'" />
      </div>
      <div class="details-container">
        <p class="product-quantity">{{ idx.quantity }}</p>
        <span>
          {{ idx.quantity }}
          <span *ngIf="idx?.unitValue"> - {{ idx?.unitValue }}</span>
          <span *ngIf="idx?.unit"> {{ idx?.unit }}</span>
        </span>
        <p class="product-price">
          <span class="price">
            {{ data?.currency ? data?.currency : '₹' }} {{ idx?.price }}
            <del class="original-price" *ngIf="!idx?.cashBack && idx.price < idx.actualPrice">
              {{ idx.actualPrice }}
            </del>
          </span>
        </p>
      </div>
    </div>
  </mat-card-content>
</mat-card>
